export const select_data_type = {
  priority: [
    { index: 'P0', name: 'P0' },
    { index: 'P2', name: 'P2' },
    { index: 'P3', name: 'P3' },
  ]
};